import { useLocation } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { useTheme } from "@/theme/ThemeContext";
import { theme } from "@/theme/theme";
import ThreeBackground from "@/components/Backgrounds/HeroBackground";
import { motion } from "framer-motion";

const NotFound = () => {
  const location = useLocation();
  const { theme: themeMode } = useTheme();
  const notFoundStyles = useMemo(() => theme.hero[themeMode], [themeMode]);
  const commonStyles = useMemo(() => theme.common[themeMode], [themeMode]);

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <section className={`relative min-h-screen flex items-center justify-center overflow-hidden ${commonStyles.background.glass}`}>
      <div className="absolute inset-0 z-0">
        <ThreeBackground />
      </div>
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-2xl px-4 py-16">
        <motion.h1
          initial={{ scale: 0.7, opacity: 0, rotateX: -45 }}
          animate={{ scale: 1, opacity: 1, rotateX: 0 }}
          transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
          className={`text-[7rem] sm:text-[10rem] font-extrabold drop-shadow-xl ${notFoundStyles.badge.text} mb-2 select-none`}
          style={{ textShadow: themeMode === 'dark' ? '0 4px 32px #ff6b35, 0 1px 0 #fff' : '0 4px 32px #0d9488, 0 1px 0 #fff' }}
        >
          404
        </motion.h1>
        <motion.p
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
          className={`text-2xl sm:text-3xl font-mono font-semibold mb-6 ${notFoundStyles.badge.text}`}
        >
          Oops! Page not found
        </motion.p>
        <motion.p
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 0.85 }}
          transition={{ duration: 0.7, delay: 0.4, ease: 'easeOut' }}
          className={`mb-10 text-lg sm:text-xl font-mono ${notFoundStyles.description.background} rounded-xl px-6 py-4 shadow-lg border`}
        >
          The page you are looking for does not exist or has been moved.<br />
          <span className="opacity-70">({location.pathname})</span>
        </motion.p>
        <motion.a
          href="/"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6, ease: 'backOut' }}
          className={`inline-block px-8 py-3 rounded-full font-mono font-bold text-lg shadow-xl transition-all duration-300 border-2 ${notFoundStyles.button.outline} hover:scale-105 hover:shadow-2xl`}
        >
          Return to Home
        </motion.a>
      </div>
    </section>
  );
};

export default NotFound;
